import React, { useRef, useState } from "react";
import ModalComponent from "../../../common/ModalComponent";
import constant, { NodeType } from "../../../../helper/constant";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUpload } from "@fortawesome/free-solid-svg-icons";
import { uploadWorkflowCustomDocumnet } from "../../../../service/ai-model.service";
import CustomLoader from "../../../common/CustomLoader";

const ManualInput = ({ showModal, setShowModal, title, nodes, onExecute }) => {
    const renderCreateDynamicForm = (list) => {
        const data = {}
        list.map(item => {
            data[item] = '';
        });
        return <WorkFlowForm fields={list} defaultFormData={data} onSubmit={onExecute} />
    }
    const renderManualInput = () => {
        const inputNode = nodes.filter(item => item.type === NodeType.InputNode);
        if (inputNode.length && inputNode[0].data.input && inputNode[0].data.input.length) {
            return renderCreateDynamicForm(inputNode[0].data.input);
        }
        return <p>No input field available. Please connect with system administrator</p>
    };

    const render = () => {
        return (
            <ModalComponent
                full
                title="Manual Input"
                show={showModal}
                handleClose={setShowModal}
                classes={'w-50'}
            >
                {renderManualInput()}
            </ModalComponent>
        )
    }
    return render();
}

export default ManualInput

const WorkFlowForm = (props) => {
    const { fields, defaultFormData, onSubmit } = props;
    const [formData, setFormData] = useState(defaultFormData);
    const [form, setForm] = useState({ error: {} })
    const [csv, setCSV] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const fileRef = useRef();

    const handleOnChange = (property, value) => {
        const data = { ...formData };
        data[property] = value;
        setFormData(data);
    };

    const handleValidation = () => {
        let formIsValid = true;
        let error = {};
        for (const k in formData) {
            if (!formData[k]) {
                formIsValid = false;
                error[k] = `${k} is required.`;
            }
        }
        setForm({ error });
        return formIsValid;
    };

    const onFormSubmit = (e) => {
        e.preventDefault();
        if (handleValidation()) {
            if (csv.length > 0) {
                uploadWorkInputDocument();
            } else {
                onSubmit({ ...formData });
            }
        }
    }

    const uploadWorkInputDocument = () => {
        setIsLoading(true);
        const formdata = new FormData();
        formdata.append("input", formData.orgName);
        csv.map((file) => {
            formdata.append('file', file);
        });
        uploadWorkflowCustomDocumnet(formdata)
            .then(r => {
                onSubmit({ ...formData, url: r.url });
            })
            .catch(() => {
                onSubmit({ ...formData })
            })
            .finally(() => setIsLoading(false));
    }

    const renderFormList = () => {
        return fields.map((item, index) => {
            const formLabel = item.replaceAll('_', ' ');
            return (
                <div key={index} className="col-sm-12 col-lg-6 pb-2">
                    <label htmlFor={`workflow-form-input-${item}`} className="capitalize bold">{formLabel}<span className="text-danger">*</span></label>
                    <input
                        id={`workflow-form-input-${item}`}
                        type="text"
                        className={`form-control workflow-form-input ${form.error[item] ? "error-br" : ""}`}
                        value={formData[item]}
                        placeholder={formLabel}
                        onChange={(e) => handleOnChange(item, e.target.value)}
                    />
                </div>
            )
        })
    }

    const renderBodyField = () => {
        return (
            <>
                <label htmlFor={`workflow-form-input-body`} className="capitalize bold">Body</label>
                <textarea
                    id={`workflow-form-input-body`}
                    type="text"
                    className={`form-control workflow-form-input ${form.error['body'] ? "error-br" : ""}`}
                    value={formData['body']}
                    placeholder='Body'
                    onChange={(e) => handleOnChange('body', e.target.value)}
                />
                {/* <small className="align-self-end">{formData['body'] ? formData['body'].length : 0}/{constant.workflowBodyLimit}</small> */}
            </>
        )
    }

    const handleFileChange = (e) => {
        if (e.target.files && e.target.files.length > 0) setCSV(Array.from(e.target.files));
    };

    const renderOptionalFileUpload = () => {
        return (
            <>
                <div className="bold" style={{ minWidth: 170 }}>Additional Information (Optional)</div>
                <div className="upload-btn-wrapper cursor-pointer">
                    <button type="button" className="btnupld-blu w-50">
                        Upload <FontAwesomeIcon icon={faUpload} />
                    </button>
                    <input
                        multiple
                        ref={fileRef}
                        type="file"
                        name="myfile"
                        onChange={handleFileChange}
                    />
                </div>

                {(csv && csv.length > 0) && csv.map((f, index) => <small key={index}>{f.name}</small>)}
            </>
        )
    }

    const render = () => {
        return (
            <>
                {isLoading && <CustomLoader full />}
                <form noValidate onSubmit={onFormSubmit} className="d-flex flex-column gap-1">
                    <h6 className="pb-2">Please fill all fields below to execute workflow</h6>
                    <div className="row">
                        {renderFormList()}
                    </div>
                    <div className="d-flex gap-1 flex-column">
                        {renderBodyField()}
                    </div>
                    <div className="d-flex gap-1 flex-column">
                        {renderOptionalFileUpload()}
                    </div>
                    {<button
                        type="submit"
                        className="btn2 btn radious-0 mt-2 f-13 text-uppercase py-3 mt-5 font15fontweight600 align-self-center">
                        Execute Workflow
                    </button>}
                </form>
            </>
        )
    }
    return render();
}